module.exports = __webpack_public_path__ + "static/img/business2.d9f1a83.png";


//////////////////
// WEBPACK FOOTER
// ./static/aboutUs/business2.png
// module id = dG13
// module chunks = 1